export default __webpack_public_path__ + "static/media/63532__florian-reinke__click2.c8b2b6d4.mp3";